import { usePathname } from 'next/navigation';
import { getCurrenWebsiteSlugFromUrl } from '../utils/getCurrentSiteSectionDetails';
import { useCommonData } from '../../../../common-data/useCommonData';

import MCOLogo from '../../../../assets/logo/mco-logo-tm.svg';
import GOAALogo from '../../../../assets/logo/goaa-logo-tm.svg';
import ORLLogo from '../../../../assets/logo/orl-logo-tm.svg';
import MCOCaresLogo from '../../../../assets/logo/mcocares-logo.svg';
import {
	BUSINESS_SITE_SECTION_ID,
	MCO_CARES_SITE_SECTION_ID,
	MCO_SITE_SECTION_ID,
	ORL_SITE_SECTION_ID,
	SiteSectionIds,
} from '../../../../contentful';
import { getOrderedSiteSections } from '../../../../navigation/getOrderedSiteSections';

type ILogoInfo = {
	svg: SVGComponent;
	className: string;
};

const websiteMap: Record<string, ILogoInfo> = {
	[MCO_SITE_SECTION_ID]: {
		svg: MCOLogo,
		className: 'mco',
	},
	[BUSINESS_SITE_SECTION_ID]: {
		svg: GOAALogo,
		className: 'business',
	},
	[ORL_SITE_SECTION_ID]: {
		svg: ORLLogo,
		className: 'orl',
	},
	[MCO_CARES_SITE_SECTION_ID]: {
		svg: MCOCaresLogo,
		className: 'mco-cares',
	},
	default: {
		svg: MCOLogo,
		className: 'mco',
	},
};

export const useGetWebsiteDetails = () => {
	const { siteSections } = useCommonData();
	const pathname = usePathname();
	const currSiteSectionSlug = getCurrenWebsiteSlugFromUrl(pathname);

	const currentSiteSection =
		siteSections.filter(
			(section) => (section.fields.slug || '') === currSiteSectionSlug,
		)[0] ||
		siteSections.filter(
			(section) => section.fields.id === SiteSectionIds.MCO,
		)[0];

	const currentSiteSectionId = currentSiteSection.fields.id;
	const websiteSettings =
		currentSiteSection && websiteMap[currentSiteSectionId]
			? websiteMap[currentSiteSectionId]
			: websiteMap.default;
	const orderedSiteSections = getOrderedSiteSections(siteSections);

	return {
		currentSiteSectionId,
		title: currentSiteSection?.fields.title,
		homeUrl: `/${currentSiteSection?.fields.slug || ''}`,
		menuItems: currentSiteSection?.fields.menuItems || [],
		currentSiteSection,
		logo: (
			<websiteSettings.svg
				className={websiteSettings.className}
				aria-label={currentSiteSection?.fields.title}
			/>
		),
		siteSections: orderedSiteSections,
	};
};
